import { useMutation } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";

export const useDeleteCourtBlockade = (onSuccess: (deletedBlockadeId: string) => void) => {
    const apiClient = useApiClient();
    const toast = useToast();
    return useMutation({
        mutationKey: ['deleteCourtBlockade'],
        mutationFn: (blockadeId: string) => apiClient.fetchApi<{}, {}>({ method: 'DELETE', endpoint: `court-temporary-blockades/${blockadeId}` }),
        onSuccess: (data, blockadeId) => {
            onSuccess(blockadeId);
        },
        onError: () => {
            toast({ title: translate('error'), status: 'error', duration: 3000, position: 'top-right' });
        }
    });
};
